module.exports = __webpack_public_path__ + "img/chevron-left.d4d70a31.svg";